module.exports = __webpack_public_path__ + "img/fangdajing.00757883.png";